export const ReviewAssignmentType = Object.freeze({
  AMP: 'amp',
  LENDER: 'lender',
})
